<template>
  <div class="min-h-dvh bg-white">
    <NuxtLoadingIndicator color="repeating-linear-gradient(to right,#ff620a 0%,#C40058 100%)" />
    <Header />
    <main class="w-full max-w-screen-2xl container flex items-center mx-auto flex-col grow">
      <slot />
    </main>
    <Footer />
    <ClientOnly>
      <CheckoutRecoveryCard />
    </ClientOnly>
  </div>
</template>
